<template>
  <div class="picture-container">
    <el-button icon="el-icon-refresh" @click="$refresh(getPicturesData)" class="refresh-btn">刷新</el-button>
    <div class="picturewrap">
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addPicture">新增图片</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="deletePictureList">批量删除</el-button>
      </div>
      <!-- 图片列表 -->
      <el-table v-loading="loading" :data="pictureList" :max-height="tableHeight"
        @selection-change="val => $handleSelectionChange(val, true)" ref="multipleTable" border>
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column prop="pictureName" label="图片名称" width="120" />
        <el-table-column prop="pictureAddr" label="图片" width="160">
          <template slot-scope="scope">
            <el-image v-model="scope.row.deptImg" :src="scope.row.pictureAddr" fit="contain" />
          </template>
        </el-table-column>
        <el-table-column prop="redirectPath" label="跳转路径" min-width="200">
          <template slot-scope="scope" v-if="scope.row.redirectPath">
            <div>{{ computedRedirectPath(scope.row) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            {{ scope.row.status == '0' ? '显示' : '隐藏' }}
          </template>
        </el-table-column>
        <el-table-column prop="updateBy" label="操作员" />
        <el-table-column prop="updateTime" label="更新时间" min-width="150" />
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="editPicture(scope.row)">修改</el-button>
            <el-button icon="el-icon-delete" type="danger" @click="deletePicture(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="pictureEdit" :title="dialogTitle" :visible.sync="dialogVisible" v-if="dialogVisible"
        :before-close="done => $handleClose(done, 'editForm')" width="500px" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline label-width="80px">
          <el-form-item label="图片名称" prop="pictureName">
            <el-input v-model.trim="editForm.pictureName" maxLength="50" placeholder="请输入图片名称" />
          </el-form-item>
          <el-form-item label="图片状态" prop="status">
            <el-radio-group v-model="editForm.status">
              <el-radio :label="'0'">显示</el-radio>
              <el-radio :label="'1'">隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="图片顺序" prop="sort">
            <el-input v-model.number="editForm.sort" placeholder="请输入图片顺序" />
          </el-form-item>
          <el-form-item label="图片上传" prop="pictureAddr">
            <div v-if="editForm.pictureAddr">
              <img :src="editForm.pictureAddr" class="img" />
              <el-button icon="el-icon-edit" type="primary" @click="editImg" class="btn">修改图片</el-button>
            </div>
            <Upload v-else v-loading="uploading" ref="uploadImage" @on-success="handleImgSuccess"
              accept=".png,.jpg,.jpeg" class="mr8">
              <el-button class="upload" type="primary" size="small">
                <i class="el-icon-plus"></i>
              </el-button>
            </Upload>
          </el-form-item>
          <el-form-item label="跳转路径">
            <el-radio-group v-model="editForm.redirectType" @change="changeRedirectType">
              <el-radio v-for="item in redirectTypeList" :key="item.value" :label="item.value">{{ item.label
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="菜单列表" v-if="editForm.redirectType == '1'" prop="redirectPath">
            <el-select v-model="editForm.redirectPath" placeholder="请选择">
              <el-option v-for="item in menuList" :key="item.id" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="医生姓名" v-if="editForm.redirectType == '2'" prop="doctorId">
            <el-select v-model="editForm.doctorId" filterable remote reserve-keyword placeholder="请输入医生姓名"
              :remote-method="remoteMethod" @change="doctorChange">
              <el-option v-for="item in doctorOptions" :key="item.doctorId" :label="item.doctorName"
                :value="item.doctorId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="链接地址" v-if="editForm.redirectType == '3'" prop="redirectPath">
            <el-input v-model="editForm.redirectPath" maxLength="200" placeholder="请输入链接地址" />
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增图片'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑图片'" @click="editSave">保存编辑</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getPicturesData)" :total="total"
        :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
    </div>
  </div>
</template>

<script>
import { pictureList, pictureEdit, pictureDelete, pictureAdd } from "@/api/picture"; // 图片请求
import Upload from '@/components/Upload/Upload'
import { uploadTemporaryFile } from "@/api/post"; // 科室请求
import { queryClientList, doctorInfo } from "@/api/doctor"
import { debounce, dictText,deepClone } from "@/utils/validateBase";
export default {
  components: { Upload },
  data() {
    return {
      loading: true, // 加载中
      searchForm: { pictureName: null, type: null }, // 查询表单
      pictureList: [], // 图片列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      dialogTitle: null, // 模态框标题
      total: 0, // 总条数
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      multipleSelection: [], // 被选中行
      uploadUrl: this.$baseUrl + '/file/upload', // 图片上传接口地址
      editFormRules: {
        sort: [{ required: true, message: "排序不能为空！" }, { type: 'number', message: "排序需为数字格式！" }],
        status: [{ required: true }],
        pictureAddr: [{ required: true, message: "图片不能为空" }],
        redirectPath: [{ required: true, message: "路径不能为空" }],
        doctorId: [{ required: true, message: "医生不能为空",trigger:'change' }],
      }, // 验证规则
      tableHeight: 0, // 表格最大高度
      uploading: false,
      redirectTypeList: [
        { label: '菜单', value: 1 },
        { label: '医生主页', value: 2 },
        { label: '动态页面', value: 3 },
        { label: '无', value: -1 },
      ],
      menuList: [
        { id: 1, label: '门诊预约', value: '/pages/deptRegister/deptRegister' },
        { id: 2, label: '在线咨询', value: '/secondPages/doctorOnlineList/doctorOnlineList' },
        { id: 3, label: '理疗预约', value: '/physio/reservationHome/reservationHome' },
        { id: 4, label: '自助续方', value: '/secondPages/selfServiceIndex/selfServiceIndex' },
        { id: 5, label: '挂号记录', value: '/secondPages/registerList/registerList' },
        { id: 6, label: '处方订单', value: '/secondPages/orderList/orderList?status=all' },
        { id: 7, label: '理疗记录', value: '/physio/reservationRecordList/reservationRecordList' },
        { id: 8, label: '我的咨询', value: '/secondPages/onlineList/onlineList' },
        { id: 9, label: '充值余额', value: '/secondPages/recharge/recharge' },
        { id: 10, label: '优惠券列表', value: '/secondPages/couponList/couponList' },
      ],
      doctorOptions: [],
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 280;
    this.getPicturesData(); // 页面初始化获取图片列表
  },
  computed: {
    computedRedirectPath() {
      return function (item) {
        let typeStr = dictText(item.redirectType, this.redirectTypeList)
        let str = null
        if (item.redirectType == 1) {
          str = `${typeStr}：${dictText(item.redirectPath, this.menuList)}`
        } else if (item.redirectType == 2) {
          let obj = JSON.parse(item.redirectPath)
          str = `${typeStr}：${obj.doctorName}`
        } else {
          str = `${typeStr}：${item.redirectPath}`
        }
        return str
      }
    },
  },
  methods: {
    // 请求图片列表
    async getPicturesData() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize };
      let { total, rows, code } = await pictureList(params);
      if (code == 200) {
        this.total = total;
        this.pictureList = rows;
      }
      this.loading = false;
    },
    // 条件查询图片列表
    search() {
      this.$refresh(this.getPicturesData, this.searchForm);
    },
    // 重置表单
    reset() {
      this.searchForm = { labelName: null, type: null };
      this.$refresh(this.getPicturesData);
    },
    // 新增图片
    addPicture() {
      this.doctorOptions = []
      this.dialogVisible = true;
      this.dialogTitle = "新增图片";
      this.editForm = { pictureName: null, pictureAddr: null, status: '0', redirectPath: null, sort: null, redirectType: null, doctorName: null,doctorId: null };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          if(this.editForm.redirectType == 2){
            let obj = {doctorId:this.editForm.doctorId,doctorName:this.editForm.doctorName }
            this.editForm.redirectPath = JSON.stringify(obj)
          }else if(this.editForm.redirectType == -1){
            this.editForm.redirectPath = ''
          }
          pictureAdd(this.editForm).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("新增图片成功！");
            this.dialogVisible = false;
            this.$refresh(this.getPicturesData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 删除图片
    deletePicture(row) {
      this.$confirm('确认删除该图片？').then(_ => { this.del(row.pictureId) }).catch(_ => { });
    },
    async del(id) {
      let { code } = await pictureDelete(id);
      if (code == 200) this.$message.success("删除图片成功！");
      this.$refresh(this.getPicturesData);
    },
    // 批量删除图片
    deletePictureList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何图片");
      else {
        selected.forEach(item => { selectedId.push(item.pictureId) });
        this.$confirm('确认删除该图片？').then(_ => { this.del(selectedId) }).catch(_ => { });
      }
    },
    // 编辑图片信息
    async editPicture(row) {
      this.dialogTitle = "编辑图片";
      this.doctorOptions = []
      this.editForm =  deepClone(row);
      this.$set(this.editForm, 'doctorId', null)
      this.$set(this.editForm, 'doctorName', null)
      if (this.editForm.redirectType == 2) {
        let obj = JSON.parse(this.editForm.redirectPath);
        doctorInfo(obj.doctorId).then(res => {
          if (res.code == 200) {
            this.editForm.doctorName = res.data.doctorName
            this.editForm.doctorId = res.data.doctorId
            this.$forceUpdate()
            this.doctorOptions.push(res.data)
          }
        })
      }
      this.dialogVisible = true;
    },
    // 保存图片修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
           if(this.editForm.redirectType == 2){
            let obj = {doctorId:this.editForm.doctorId,doctorName:this.editForm.doctorName }
            this.editForm.redirectPath = JSON.stringify(obj)
          }else if(this.editForm.redirectType == -1){
            this.editForm.redirectPath = ''
          }
          pictureEdit(this.editForm).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("修改图片信息成功！");
            this.dialogVisible = false;
            this.$refresh(this.getPicturesData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 图片上传成功的函数
    handleImgSuccess(data) {
      // let { code, msg } = res;
      // if (code === 200) this.editForm.pictureAddr = msg;
      this.uploading = true
      let arr = []
      arr[0] = { uploadChannel: "postImg", fileId: data, groupName: "group1", isNeedThumbnail: "2" }
      uploadTemporaryFile(arr).then(uploadRes => {
        this.uploading = false
        if (uploadRes.errorCode == '0000') {
          this.editForm.pictureAddr = uploadRes.data[0].fullPathUrl
        } else {
          this.$message.error('上传失败')
        }
      }).catch(err => {
        this.uploading = false;
        this.$message.error('上传失败')
      })
    },
    // 清除图片地址，显示上传图片
    editImg() {
      this.editForm.pictureAddr = null;
    },
    changeRedirectType(val) {
      this.doctorOptions = []
      this.editForm.redirectPath = null
      if(val == 2){
        this.$set(this.editForm, 'doctorId', '')
        this.editForm.doctorName = null
      }
    },
    remoteMethod: debounce(async function (query) {
      let { code, rows } = await queryClientList({ searchValue: query, pageSize: 100, pageNum: 1 })
      if (code === 200) {
        this.doctorOptions = rows
      }
    }, 300, true),
    doctorChange(val){
      let info = this.doctorOptions.find(item => item.doctorId == val)
      this.editForm.doctorName = info.doctorName
      this.editForm.doctorId = val
      this.$forceUpdate()
    }
  },
};
</script>

<style lang="less" scoped>
.picture-container {
  height: 100%;
  overflow: auto;
}

.picturewrap {
  &>div:not(:last-child) {
    margin-bottom: 20px;
  }

  .el-form-item {
    width: 430px;
  }

  .el-input,
  .el-textarea {
    width: 280px;
  }

  .img {
    width: 200px;
    height: auto;
    display: block;
  }

  .btn {
    margin-top: 5px;
  }

  .el-iamge {
    width: auto;
    height: 100px;
    margin-top: 5px;
  }

  .upload {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 2px;
    border: 1px dashed #D3D3D5;
    background-color: #FFF;
    color: #9AA0A8;
  }
}
</style>